import React from 'react';
import MetricTile from './MetricTile';

const MetricGroup = ({ metricGroup = [] }) => (
  <>
    <React.Fragment key="cards">
      {
        metricGroup.map(metric => (
          <MetricTile
            key={metric.name}
            metric={metric.name}
            metricValue={metric.value}
          />
        ))
      }
    </React.Fragment>
  </>
);

export default MetricGroup;
